import { Link } from "react-router-dom";
import { Section } from "../components/sections";

export default function NotFoundPage() {
  return (
    <Section testId="not-found-page">
      <p className="overline mb-6">404</p>
      <h1
        className="font-serif-display font-light text-white leading-[1.05] tracking-tight"
        style={{ fontSize: "clamp(48px, 8vw, 120px)", letterSpacing: "-0.03em" }}
      >
        Page <em className="italic" style={{ color: "#C2533B" }}>not found.</em>
      </h1>
      <p className="mt-6 text-zinc-400 text-lg max-w-xl leading-relaxed">
        The page you were looking for is no longer here, or never was. Try the links below.
      </p>
      <div className="mt-12 flex flex-col sm:flex-row gap-4">
        <Link to="/" className="btn-primary">
          Back to Home
        </Link>
        <Link to="/contact" className="btn-secondary">
          Contact Us
        </Link>
      </div>
    </Section>
  );
}
